// extracted by mini-css-extract-plugin
export default {"colorPicker":"colorPicker_colorPicker__IPtm+","pressColorPicker":"colorPicker_pressColorPicker__EkBLQ","wrapperPressColorPicker":"colorPicker_wrapperPressColorPicker__k+ou2"};